// extracted by mini-css-extract-plugin
export var errorIcon = "_jl-1";
export var nameLogo = "_jl-0";